import React from 'react';

const EVerifyEmail = (): JSX.Element => {
  return (
    <a
      href="mailto:E-Verify@uscis.dhs.gov"
      aria-label="Send an email to E-Verify@uscis.dhs.gov"
      target="_blank"
      rel="noopener noreferrer"
    >
      E-Verify@uscis.dhs.gov
    </a>
  );
};
export default EVerifyEmail;
